import API_CALL from "services/API";

const geoServerUrl = process?.env?.REACT_APP_GEOSERVER_URL;

const ServiceGeoServer = {
  getProjectWfs: async ({ uuid }: { uuid: string }) => {
    return API_CALL({
      url: geoServerUrl + "/ows",
      params: {
        service: "WFS",
        version: "1.1.0",
        request: "GetFeature",
        typename: "airtree:airtree_project",
        CQL_FILTER: `uuid='${uuid}'`,
        outputFormat: "application/json",
        srsname: "EPSG:3857",
      },
    }).then((res) => res);
  },

  getProjectElementsWfs: async ({ idProject }: { idProject: number }) => {
    return API_CALL({
      url: geoServerUrl + "/ows",
      params: {
        service: "WFS",
        version: "1.1.0",
        request: "GetFeature",
        typename: "airtree:airtree_project_elements",
        CQL_FILTER: `id_project='${idProject}'`,
        outputFormat: "application/json",
        srsname: "EPSG:3857",
      },
    }).then((res) => res);
  },

  getItalianRegionsShape: async () => {
    return API_CALL({
      url: geoServerUrl + "/ows",
      params: {
        service: "WFS",
        version: "1.0.0",
        request: "GetFeature",
        typename: "forestview:regioni_italia_2022",
        outputFormat: "application/json",
        srsname: "EPSG:3857",
      },
    }).then((res) => res);
  },

  getItalianRegionsShapeIntersect: async (xc, yc) => {
    return API_CALL({
      url: geoServerUrl + "/ows",
      params: {
        service: "WFS",
        version: "1.0.0",
        request: "GetFeature",
        typename: "forestview:regioni_italia_2022",
        outputFormat: "application/json",
        srsname: "EPSG:3857",
        CQL_FILTER: `INTERSECTS(the_geom,SRID=3857;POINT(${xc} ${yc}))`,
      },
    }).then((res) => res);
  },

  calculateForestViewStatistic: async (raster, poly_coordinaets) => {
    let data = `<?xml version="1.0" encoding="UTF-8"?><wps:Execute version="1.0.0" service="WPS" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.opengis.net/wps/1.0.0" xmlns:wfs="http://www.opengis.net/wfs" xmlns:wps="http://www.opengis.net/wps/1.0.0" xmlns:ows="http://www.opengis.net/ows/1.1" xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" xmlns:wcs="http://www.opengis.net/wcs/1.1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xsi:schemaLocation="http://www.opengis.net/wps/1.0.0 http://schemas.opengis.net/wps/1.0.0/wpsAll.xsd"><ows:Identifier>ras:RasterZonalStatistics</ows:Identifier><wps:DataInputs><wps:Input><ows:Identifier>data</ows:Identifier><wps:Reference mimeType="image/tiff" xlink:href="http://geoserver/wcs" method="POST"><wps:Body>
    <wcs:GetCoverage service="WCS" version="1.1.1">
      <ows:Identifier>${raster}</ows:Identifier>
      <wcs:DomainSubset>
        <ows:BoundingBox crs="http://www.opengis.net/gml/srs/epsg.xml#32632">
          <ows:LowerCorner>313260.0 4020285.0</ows:LowerCorner>
          <ows:UpperCorner>1313300.0 5220310.0</ows:UpperCorner>
        </ows:BoundingBox>
      </wcs:DomainSubset>
      <wcs:Output format="image/tiff"/>
    </wcs:GetCoverage>
    </wps:Body>
    </wps:Reference>
    </wps:Input>
    <wps:Input>
    <ows:Identifier>zones</ows:Identifier>
    <wps:Data>
    <wps:ComplexData mimeType="application/json"><![CDATA[{
    "type": "FeatureCollection",
    "name": "poli",
    "crs": {
        "type": "name",
        "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
        }
    },
    "features": [
        {
            "type": "Feature",
            "properties": {},
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [${JSON.stringify(poly_coordinaets)}]
            }
        }
    ]
    }
    ]]></wps:ComplexData>
    </wps:Data>
    </wps:Input>
    </wps:DataInputs>
    <wps:ResponseForm>
    <wps:RawDataOutput mimeType="text/xml; subtype=wfs-collection/1.0">
    <ows:Identifier>statistics</ows:Identifier>
    </wps:RawDataOutput>
    </wps:ResponseForm>
    </wps:Execute>`;

    return API_CALL({
      method: "POST",
      headers: { "Content-Type": "application/xml" },
      url: geoServerUrl + "/ows",
      data: data,
      params: {
        service: "wps",
      },
    }).then((res) => res);
  },

  getWmsAccessiBoschivi: async () => {
    return API_CALL({
      url: geoServerUrl + "/wms",
      params: {
        service: "WMS",
        version: "1.1.1",
        request: "GetFeatureInfo",
        layers: "italy_aspect_slope:racc_ita_30m",
        query_layers: "italy_aspect_slope:racc_ita_30m",
        infoFormat: "application/json",
        srs: "EPSG:3857",
        // bbox: "313280,3933700,1312010,5220280",
        // x: "313280",
        // y: "3933700",
        //params: { LAYERS: "italy_aspect_slope:racc_ita_30m", TILED: true },
        //serverType: "geoserver",
        //transition: 0,
      },
    }).then((res) => res);
  },
};
export default ServiceGeoServer;
